import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../components/PageHeader/PageHeader';
import CustomTabPanel from '../../components/Tab/CustomTabPanel';
import TemplatesTab from './templates/TemplatesTab';
import ListsTab from './lists/ListsTab';
import SendTab from './send/SendTab';
import HistoryTab from './history/HistoryTab';

const Emails = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleChangeTab} aria-label="email tabs">
          <Tab label={t('templates')} />
          <Tab label={t('email_lists')} />
          <Tab label={t('send_email')} />
          <Tab label={t('email_history')} />
        </Tabs>
      </Box>

      <CustomTabPanel value={tabValue} index={0}>
        <PageHeader title={t('templates')} subtitle={t('manage_email_templates')} />
        <TemplatesTab />
      </CustomTabPanel>

      <CustomTabPanel value={tabValue} index={1}>
        <PageHeader title={t('email_lists')} subtitle={t('manage_email_lists')} />
        <ListsTab />
      </CustomTabPanel>

      <CustomTabPanel value={tabValue} index={2}>
        <PageHeader title={t('send_email')} subtitle={t('send_or_schedule_emails')} />
        <SendTab />
      </CustomTabPanel>

      <CustomTabPanel value={tabValue} index={3}>
        <PageHeader title={t('email_history')} subtitle={t('view_sent_emails_and_metrics')} />
        <HistoryTab />
      </CustomTabPanel>
    </Box>
  );
};

export default Emails;

